import './PractitionerAdd.scss';
import React, { useState } from 'react';
import Heading from '../../common/Heading/Heading';
import {
  App,
  Button,
  Card,
  Col,
  Divider,
  Form,
  Input,
  Row,
  Select,
  Space,
  Spin,
  Table,
} from 'antd';
import {PlusOutlined } from '@ant-design/icons';
import { queryKeys } from '../../../services/react-query/queryKeys';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import {
  addPractitioner,
  get_account_details,
  get_contract_type,
  get_Specialty,
  getDepartments,
  getPractitionerSchedules,
  getPractitionersDetails,
  updatePractitioner,
} from '../../../network/practitioners';
import { MdDelete } from 'react-icons/md';
import PhoneInputWithCountrySelect, {
  isValidPhoneNumber,
} from 'react-phone-number-input';
import { useNavigate, useParams } from 'react-router-dom';
import { getServiceUnits } from '../../../network/serviceUnits';
import { useSelector } from 'react-redux';
import { getPriceLists, getServices } from '../../../network/Item';
import { getSearchApiAcount } from '../../../network/itemList';

const PractitionerAdd = ({ t, edit }) => {
  const [form] = Form.useForm();
  const [loadingAdd, setLoadingAdd] = useState(false);
  const { id } = useParams();
  const client = useQueryClient();
  const [searchTxt, setSearchTxt] = useState('');
  const navigate = useNavigate();
  const { message } = App.useApp();
  const { currentLang } = useSelector((state) => state.user);

  const { mutate: onAddPractitioner } = useMutation({
    mutationKey: ['addPatient'],
    mutationFn: (body) =>
      edit ? updatePractitioner(id,body) : addPractitioner(body),
    onSuccess: (data) => {
      setLoadingAdd(false);
      // console.log(data?.message, 'datawwww');
      if (data?.message?.status === 500) {
        message.error(data?.message?.message);
        return false;
      }
      form.resetFields();
      message.success(edit ? 'Practitioner edited successfully' : 'Practitioner added successfully');
      client.invalidateQueries({
        queryKey: [queryKeys.practitioners],
      });
      setTimeout(() => {  
        navigate('/practitioners');
      }, 100)
    },
    onError: (error) => {
      setLoadingAdd(false);
      console.log('error:', error);
      // message.error(error);
    },
  });

  const { data: practitioner_schedules } = useQuery({
    queryKey: [queryKeys.get_practitioner_schedules],
    queryFn: () => getPractitionerSchedules(),
    keepPreviousData: true,
  });

  const { data: service_units } = useQuery({
    queryKey: [queryKeys.getServiceUnits],
    queryFn: () => getServiceUnits(),
    keepPreviousData: true,
  });
  const { data: specialty } = useQuery({
    queryKey: [queryKeys.get_Specialty, currentLang],
    queryFn: () => get_Specialty(currentLang),
    keepPreviousData: true,
  });
  const { data: contract_type } = useQuery({
    queryKey: [queryKeys.get_contract_type, currentLang],
    queryFn: () => get_contract_type(currentLang),
    keepPreviousData: true,
  });
  // const { data: account_details } = useQuery({
  //   queryKey: [queryKeys.get_account_details, currentLang],
  //   queryFn: () => get_account_details(currentLang),
  //   keepPreviousData: true,
  // });
  const { data: servicesList } = useQuery({
    queryKey: [queryKeys.getServices],
    queryFn: () => getServices(),
    keepPreviousData: true,
  });
  const { data: departments } = useQuery({
    queryKey: [queryKeys.getDepartments],
    queryFn: () => getDepartments(),
    keepPreviousData: true,
  });
  const { data: practitionersInfo, isLoading: loadingPractitioner } = useQuery({
    queryKey: [queryKeys.getPractitionersDetails, id],
    queryFn: () => getPractitionersDetails(id),
    keepPreviousData: false,
    enabled: edit,
  });
  const { data: priceLists } = useQuery({
    queryKey: [queryKeys.getPriceLists],
    queryFn: () => getPriceLists(),
    keepPreviousData: true,
  });
  const { data: account } = useQuery({
    queryKey: [queryKeys.getSearchApiAccount,searchTxt],
    queryFn: () => getSearchApiAcount({type:'Account',searchTxt:searchTxt}),
    enabled: searchTxt?.length >= 3 || searchTxt?.length === 0,
    keepPreviousData: true,
  });
  

  // console.log(departments, 'departments');
  const onFinish = (values) => {
    console.log('Finish:', values);
    setLoadingAdd(true);
   onAddPractitioner({
    ...values,
    name: id,
    })
  };
  if (loadingPractitioner) {
    return (
      <div
        style={{
          width: '100%',
          height: '80vh',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <Spin size="large" />
      </div>
    );
  }
  return (
    <div className="PractitionerAdd">
      <Heading
        title={t.practitioner}
        subTitle={edit ? t.editPractitioner : t.createPractitioner}
        path="/practitioners"
      />
      <Card>
        <h4 className="title-card">{t.titleCardAddPractitioner}</h4>
        <Form
          layout="vertical"
          name="nest-messages"
          onFinish={onFinish}
          form={form}
          initialValues={
            edit
              ? {
                  ...practitionersInfo?.data,
                  practitioner_schedules:
                  practitionersInfo?.data?.practitioner_schedules.length ? 
                    practitionersInfo?.data?.practitioner_schedules?.map(
                      (s) => {
                        return {
                          schedule: s?.schedule,
                          service_unit: s?.service_unit,
                        };
                      }
                    )
                    : [{}],
                }
              : {
                  practitioner_schedules: [{}],
                }
          }
        >
          <Row gutter={[16, 0]}>
            <Col xs={24} sm={12} md={8} lg={8}>
              <Form.Item
                name="first_name"
                label={t.firstName}
                rules={[
                  {
                    required: true,
                    message: t.requiredFirstName,
                  },
                ]}
              >
                <Input placeholder={t.firstName} />
              </Form.Item>
            </Col>
            {/* <Col xs={24} sm={12} md={8} lg={8}>
                  <Form.Item
                    name="middle_name"
                    label={t.middleName}
                  
                  >
                    <Input placeholder={t.middleName} />
                  </Form.Item>
                </Col> */}
            <Col xs={24} sm={12} md={8} lg={8}>
              <Form.Item
                name="last_name"
                label={t.lastName}
                rules={[
                  {
                    required: true,
                    message: t.requiredLastName,
                  },
                ]}
              >
                <Input placeholder={t.lastName} />
              </Form.Item>
            </Col>

            <Col xs={24} sm={12} md={8} lg={8}>
              <Form.Item
                name="gender"
                label={t.gender}
                rules={[
                  {
                    required: true,
                    message: t.requiredGender,
                  },
                ]}
              >
                <Select
                  placeholder={t.gender}
                  options={[
                    {
                      value: 'Male',
                      label: t.male,
                    },
                    {
                      value: 'Female',
                      label: t.female,
                    },
                  ]}
                />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12} md={8} lg={8}>
              <Form.Item
                name="mobile_phone"
                label={t.mobile}
                className="w-full"
                rules={[
                  {
                    required: true,
                  },
                  {
                    validator: (rule, value) => {
                      console.log(value, 'value');
                      if (isValidPhoneNumber(value)) {
                        return Promise.resolve();
                      }
                      return Promise.reject('رقم الجوال غير صالح');
                    },
                  },
                ]}
                // hasFeedback
              >
                <PhoneInputWithCountrySelect
                  defaultCountry="SA"
                  className="w-full"
                  name="phone"
                  label={t.mobile}
                  international
                  // hasFeedback
                  limitMaxLength={true}
                />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12} md={8} lg={8}>
              <Form.Item
                name="residence_phone"
                label={t.phoneNumber}
                className="w-full"
                required={false}
                // hasFeedback
              >
                <PhoneInputWithCountrySelect
                  defaultCountry="SA"
                  className="w-full"
                  name="phone"
                  label={t.phoneNumber}
                  international
                  // hasFeedback
                  limitMaxLength={true}
                />
              </Form.Item>
            </Col>
            {/* <Col xs={24} sm={12} md={8} lg={8}>
              <Form.Item
                name="office_phone"
                label={t.officePhone}
                className="w-full"
                required={false}
                hasFeedback
              >
                <PhoneInputWithCountrySelect
                  defaultCountry="SA"
                  className="w-full"
                  name="office_phone"
                  label={t.phoneNumber}
                  international
                  // hasFeedback
                  limitMaxLength={true}
                />
              </Form.Item>
            </Col> */}
            {/* <Col xs={24} sm={12} md={8} lg={8}>
              <Form.Item
                name="practitioner_type"
                label={t.practitionerType}
                rules={[
                  {
                    required: true,
                    message: t.requiredPractitionerType,
                  },
                ]}
              >
                <Select
                  placeholder={t.practitionerType}
                  options={[
                    {
                      value: 'Internal',
                      label: t.internal,
                    },
                    {
                      value: 'External',
                      label: t.external,
                    },
                  ]}
                />
              </Form.Item>
            </Col> */}
            <Col xs={24} sm={12} md={8} lg={8}>
              <Form.Item
                name="department"
                label={t.medicalDepartment}
                rules={[
                  {
                    required: true,
                    message: t.requiredDepartment,
                  },
                ]}
              >
                <Select
                  placeholder={t.medicalDepartment}
                  showSearch
                  optionFilterProp="children"
                  filterOption={(input, option) =>
                    (option?.label ?? '').toLocaleLowerCase().includes(input)
                  }
                  filterSort={(optionA, optionB) =>
                    (optionA?.label ?? '')
                      .toLowerCase()
                      .localeCompare((optionB?.label ?? '').toLowerCase())
                  }
                  options={departments?.message?.departments?.map(
                    (department) => ({
                      value: department.name,
                      label: department.department,
                    })
                  )}
                />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12} md={8} lg={8}>
              <Form.Item
                name="custom_contract_type"
                label={t.contract_type}
                rules={[
                  {
                    required: true,
                    message: t.requiredDepartment,
                  },
                ]}
              >
                <Select
                  placeholder={t.contract_type}
                  showSearch
                  optionFilterProp="children"
                  filterOption={(input, option) =>
                    (option?.label ?? '').toLocaleLowerCase().includes(input)
                  }
                  filterSort={(optionA, optionB) =>
                    (optionA?.label ?? '')
                      .toLowerCase()
                      .localeCompare((optionB?.label ?? '').toLowerCase())
                  }
                  contract
                  type
                  options={contract_type?.message?.contract_type?.map((s) => ({
                    value: '' + s?.name,
                    label: s?.[currentLang],
                  }))}
                />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12} md={8} lg={8}>
              <Form.Item
                name="custom_specialty"
                label={t.Specialty}
                rules={[
                  {
                    required: true,
                    message: t.requiredDepartment,
                  },
                ]}
              >
                <Select
                  placeholder={t.Specialty}
                  showSearch
                  optionFilterProp="children"
                  filterOption={(input, option) =>
                    (option?.label ?? '').toLocaleLowerCase().includes(input)
                  }
                  filterSort={(optionA, optionB) =>
                    (optionA?.label ?? '')
                      .toLowerCase()
                      .localeCompare((optionB?.label ?? '').toLowerCase())
                  }
                  options={specialty?.message?.Specialty?.map((Specialty) => ({
                    value: '' + Specialty?.name,
                    label: Specialty?.[currentLang],
                  }))}
                />
              </Form.Item>
            </Col>

            <Divider orientation="left">{t.Accounts}</Divider>

            <Col xs={24} sm={12} md={12} lg={12}>
              <Form.Item
                name="custom_income_account"
                label={t.accountDetails}
                // rules={[
                //   {
                //     required: true,
                //     message: t.requiredAccountDetails,
                //   },
                // ]}
              >
                {/* <Select placeholder={t.accountDetails}>
                  {account_details?.message?.accounts?.map((account) => (
                    <Select.Option value={account?.name}>
                      {account?.name}
                    </Select.Option>
                  ))}
                </Select> */}
                <Select
                            placeholder={t.accountDetails}
                            style={{ width: '100%' }}
                            onSearch={(value) => {
                              setSearchTxt(value);
                            }}
                            showSearch
                            filterOption={false}
                            allowClear
                            onClear={() => {
                              setSearchTxt('');
                            }}
                            onChange={()=>{
                              setSearchTxt('');
                            }}
                            options={account?.message?.map((item) => ({
                              value: item?.value,
                              label: item?.value,
                            }))}
                          />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12} md={12} lg={12}>
              <Form.Item
                name="op_consulting_charge"
                label={t.op_consulting_charge}
              >
                <Input
                  type="number"
                  min={0}
                  placeholder={t.op_consulting_charge}
                />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12} md={12} lg={12}>
              <Form.Item name="op_consulting_charge_item" label={t.charge_item}>
                <Select
                  placeholder={t.charge_item}
                  options={servicesList?.message?.items?.map((item) => ({
                    value: item?.name,
                    label: item?.name,
                  }))}
                />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12} md={12} lg={12}>
              <Form.Item name="custom_price_list" label={t.priceList}>
                <Select
                  showSearch
                  placeholder={t.priceList}
                  optionFilterProp="children"
                  filterOption={(input, option) =>
                    option.children
                      .toLowerCase()
                      .indexOf(input.toLowerCase()) >= 0
                  }
                  options={priceLists?.message?.price_lists?.map((item) => ({
                    value: item.name,
                    label: item.name,
                  }))}
                />
              </Form.Item>
            </Col>
            <Divider orientation="left">{t.practitionerSchedule}</Divider>
            <Col span={24} className="schedule">
              <Form.List
                name="practitioner_schedules"
                style={{ width: '100%' }}
              >
                {(fields, { add, remove }) => (
                  <>
                    {fields?.map(({ key, name, ...restField }) => (
                      <Space
                        key={key}
                        style={{
                          display: 'flex',
                          marginBottom: 8,
                          justifyContent: 'space-between',
                          alignItems: 'center',
                          width: '100%',
                        }}
                        align="baseline"
                      >
                        <Form.Item
                          name={[name, 'schedule']}
                          label={t.practitionerSchedule}
                          style={{ width: '100%', marginBottom: '0px' }}
                          {...restField}
                          rules={[
                            {
                              required: true,
                            },
                          ]}
                        >
                          <Select
                            placeholder={t.practitionerSchedule}
                            style={{ width: '100%' }}
                            options={practitioner_schedules?.message?.practitioner_schedules?.map(
                              (country) => ({
                                value: country.name,
                                label:
                                  currentLang === 'en'
                                    ? country.en
                                    : country.ar,
                              })
                            )}
                          />
                        </Form.Item>
                        <Form.Item
                          name={[name, 'service_unit']}
                          style={{ width: '100%', marginBottom: '0px' }}
                          {...restField}
                          label={t.serviceUnit}
                          rules={[
                            {
                              required: true,
                            },
                          ]}
                        >
                          <Select
                            placeholder={t.serviceUnit}
                            style={{ width: '100%' }}
                            options={service_units?.message?.service_units?.map(
                              (country) => ({
                                value: country.name,
                                label:
                                  currentLang === 'en'
                                    ? country.en
                                    : country.ar,
                              })
                            )}
                          />
                        </Form.Item>
                        <div
                          style={{
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            fontSize: '15px',
                            margin: '0 10px',
                          }}
                        >
                          {fields.length > 1 && (
                            <Button
                              type="text"
                              onClick={() => remove(name)}
                              danger
                              icon={<MdDelete color="red" />}
                            />
                          )}
                          <Button
                            type="text"
                            onClick={() => add()}
                            icon={<PlusOutlined color="#1890ff" />}
                          />
                        </div>
                      </Space>
                    ))}
                  </>
                )}
              </Form.List>
            </Col>
            {/* <Col xs={24} sm={12} md={8} lg={8}>
              <Form.Item
                name="op_consulting_charge_item"
                label={t.outPatient}
                rules={[
                  {
                    required: true,
                    message: t.requiredOutPatient,
                  },
                ]}
              >
                <Select
                  placeholder={t.outPatient}
                  options={practitionerItems?.message?.departments?.map(
                    (practitionerItem) => ({
                      value: practitionerItem.name,
                      label: practitionerItem.name,
                    })
                  )}
                />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12} md={8} lg={8}>
              <Form.Item
                name="op_consulting_charge"
                label={t.outPatientCharge}
                rules={[
                  {
                    required: true,
                    message: t.requiredOutPatientCharge,
                  },
                ]}
              >
                <Input placeholder={t.outPatientCharge} />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12} md={8} lg={8}>
              <Form.Item
                name="inpatient_visit_charge_item"
                label={t.inPatientItem}
                rules={[
                  {
                    required: true,
                    message: t.requiredInPatientItem,
                  },
                ]}
              >
                <Select placeholder={t.inPatientItem}>
                  <Select.Option value="sample">{t.sampleLab}</Select.Option>
                </Select>
              </Form.Item>
            </Col>
            <Col xs={24} sm={12} md={8} lg={8}>
              <Form.Item
                name="inpatient_visit_charge"
                label={t.inPatientVisit}
                rules={[
                  {
                    required: true,
                    message: t.requiredInPatientVisit,
                  },
                ]}
              >
                <Input placeholder={t.inPatientVisit} />
              </Form.Item>
            </Col> */}
          </Row>
          <div className="form-btns">
            <Button
              type="primary"
              ghost
              onClick={() => navigate('/practitioners')}
            >
              {t.Cancel}
            </Button>
            <Button type="primary" htmlType="submit" loading={loadingAdd}>
              {edit ? t.edit : t.submit}
            </Button>
          </div>
        </Form>
      </Card>
    </div>
  );
};

export default PractitionerAdd;
